// extracted by mini-css-extract-plugin
var _1 = "details-img___mZ9Kn";
export { _1 as "details-img" }
